import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { history } from "../../../helpers";
import { routePaths } from "../../config/route-paths";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import EConfirmation from "./view/_confirmation";
import ESummaryDetails from "./view/_summary-details";
import EFooter from "../../e_home-page/e_footer-section/view/_footer";
import { useState, useEffect } from "react";
import { ticketService } from "../model/_service";
import Alert from "@material-ui/lab/Alert";
import { config } from "../../../enviroment";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  header: {
    color: theme?.palette?.ePrimary?.base,
    fontWeight: "bold",
    marginLeft: "1rem",
  },
  back: {
    color: theme?.palette?.ePrimary?.base,
    fontWeight: "bold",
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  contentBg: {
    backgroundColor: theme?.palette?.eWhite?.base + " !important",
    paddingBottom: "1% !important",
  },
  cardStyle: {
    minHeight: "95vh",
  },
  footerSection: {
    height: "100%",
    marginLeft: "0.2rem",
    backgroundColor: theme?.palette?.eWhite?.base + " !important",
  },
  details: {
    marginLeft: "1rem",
  },
  cardContentPadding: {
    paddingTop: "0.3rem",
    paddingBottom: "0.3rem !important",
    height: "100%",
  },
  contentBg: {
    background: theme?.palette?.eLight?.base + " !important",
    padding: "1.5rem 1.5rem 0rem !important",
    paddingBottom: 0,
    [theme.breakpoints.down("xs")]: {
      padding: "0px !important",
      paddingBottom: "8%",
    },
  },
  padding: {
    paddingLeft: "2%",
  },
  marg: {
    marginTop: "1%",
  },
}));
export default function ESummaryReview(props) {
  const {
    noofconnections,
    setActiveStep,
    setTicketNumber,
    name,
    fatherName,
    husbandWifeRadio,
    husbandName,
    motherName,
    email,
    mobile,
    idType,
    idValue,
    dropDownData,
    individualVerifiedMobile,
    tarrifType,
    Load,
    meterType,
    idTypeOthers,
    isIndividualMobileVerified,
    existingCustomer,
    existingCustomerID,
    connectionType,
    connectionTypeCode,
    sameAsPremiseCheck,
    handleClickOpen,
    districtPremise,
    address1Premise,
    address2Premise,
    postOfficePremise,
    divisionPremise,
    divisionCodePremise,
    postCodePremise,
    thanaPremise,
    districtMailing,
    address1Mailing,
    address2Mailing,
    postOfficeMailing,
    divisionMailing,
    divisionCodeMailing,
    postCodeMailing,
    thanaMailing,
    checkBoxEnable,
    connectionOnExistingPremise,
    premiseType,
    premiseCategory,
    idTypeCode,
    tarrifTypeCode,
    meterTypeCode,
    premiseTypeCode,
    premiseCategoryCode,
    termsAgreedTime,
    documentList,
    setApplicationDate,
    tinTypeCode,
    tinValue,
    sndCode,
    sndValue,
    userEnteredMobileNumber,
            masterDataEmail,
            masterDataName,
            masterDataIdValue,
            masterDataTinValue,
            masterDataFatherName,
            masterDataMotherName,
            masterDataHusbandName,
            masterDataAddress1Mailing,
            masterDataAddress2Mailing,
            masterDataPostOfficeMailing,
            masterDataPostCodeMailing,
            masterDataDistrictMailing,
            masterDataDivisionCodeMailing,
            masterDataDivisionMailing,
            masterDataThanaMailing,
            masterDatahusbandWifeRadio
  } = props;
  const [mobileWithExtension, setMobileWithExtension] = useState("");
  const summaryClass = useStyles();
  const summaryReviewLabel = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_SUMMARY_REVIEW
  );
  const extension = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_PHONE_NUMBER_EXTENSION
  );
  const backCall = () => {
    setActiveStep(2);
  };
  useEffect(() => {
    if(extension && (mobile ||userEnteredMobileNumber)) {
      let extensionNumer = extension.replace(/\+/g, "");
      let mobileNo =  existingCustomer=="yes" ? "(" + extensionNumer + ") " + (userEnteredMobileNumber) : "(" + extensionNumer + ") " + (mobile) ;
      setMobileWithExtension(mobileNo);
    }
  },[extension, mobile,userEnteredMobileNumber])
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  const [allAttachedFiles, setAllAttachedFiles] = useState([]);

  useEffect(() => {
    let tempArray = [];
    let count = 0;
    if (documentList.length !== 0) {
      documentList.map((item) => {
        if (item && item.files && item.files.length !== 0) {
          item.files.map((element) => {
            element.seq = "" + count;
            count = Number(count) + 1;
            element.attachmentFor = item.dropDownCode;
            return tempArray.push(element);
          });
        }
      });
    }
    setAllAttachedFiles(tempArray);
  }, [documentList]);
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const HUSBAND_RADIO_VALUE = "husband";
  const WIFE_RADIO_VALUE = "wife";
  const [data, setData] = useState();
  const [error, setError] = useState(false);
  const [newConnectionData, setNewConnection] = useState({});
  let gethusbandName= existingCustomer=="yes"? masterDatahusbandWifeRadio==HUSBAND_RADIO_VALUE?masterDataHusbandName:"":husbandWifeRadio == HUSBAND_RADIO_VALUE?husbandName:""
  let getwifeName=existingCustomer=="yes"? masterDatahusbandWifeRadio==WIFE_RADIO_VALUE?masterDataHusbandName:"":husbandWifeRadio == WIFE_RADIO_VALUE?husbandName:""
  useEffect(() => {
    let newConnectionData = {
      action: "APPLICATION_DETAILS",
      languageCode: languageCode,
      applicationDetails: {
        applicationId: existingCustomer=="yes"?masterDataIdValue:idValue,
        connectionType: connectionTypeCode,
        noOfConnection:noofconnections,
        demographicInfo: {
          name: existingCustomer=="yes"?masterDataName:name,
          fatherName: existingCustomer=="yes"?masterDataFatherName:fatherName ? fatherName : "",
          motherName: existingCustomer=="yes"?masterDataMotherName:motherName ? motherName : "",
          husbandName: gethusbandName,
          wifeName: getwifeName,
          mobileNumber: mobileWithExtension,
          emailId:existingCustomer=="yes"?masterDataEmail: email ? email : "",  
          Id:{
            IdList:[
              {
                seq:"0",
                IdType: idTypeCode,
                 IdValue: existingCustomer=="yes"?masterDataIdValue:idValue,
              },
              {
                seq:"1",
                IdType: tinTypeCode,
               IdValue:existingCustomer=="yes"?masterDataTinValue: tinValue,
              }
            ]
          },
          communicationAddress: {
            comAddress1: address1Premise,
            comAddress2: address2Premise ? address2Premise : "",
            comPostOffice: postOfficePremise ? postOfficePremise : "",
            comThanaUpzilla: thanaPremise ? thanaPremise : "",
            comDistrict: districtPremise,
            comDivision: divisionCodePremise,
            comPostCode: postCodePremise,
            conSnd: sndCode
          },
        },
        applicationInfo: {
          tariffType: tarrifTypeCode ? tarrifTypeCode : "",
          load: Load ? Load : "",
          meterType: meterTypeCode ? meterTypeCode : "",
        },
        connectionOnExistingPremise: "N",
        existingC2MPremiseId: "",
        premiseInfo: {
          connectionAddress: {
            conAddress1: existingCustomer=="yes"?masterDataAddress1Mailing:address1Mailing,
            conAddress2:  existingCustomer=="yes"?masterDataAddress2Mailing:address2Mailing ? address2Mailing : "",
            conPostOffice: existingCustomer=="yes"?masterDataPostOfficeMailing:postOfficeMailing ? postOfficeMailing : "",
            conThanaUpzilla:existingCustomer=="yes"? masterDataThanaMailing:thanaMailing ? thanaMailing: "",
            conDistrict: existingCustomer=="yes"?masterDataDistrictMailing:districtMailing,
            conDivision: existingCustomer=="yes"?masterDataDivisionCodeMailing:divisionCodeMailing,
            conPostCode: existingCustomer=="yes"?masterDataPostCodeMailing:postCodeMailing
          },
          premiseType: premiseTypeCode ? premiseTypeCode : "",
          premiseCategory: premiseCategoryCode ? premiseCategoryCode : "",
        },
      },
    };
    setNewConnection(newConnectionData)
  },[languageCode,idValue,connectionTypeCode,name,fatherName,motherName,mobileWithExtension,email,idTypeCode,idValue,address1Premise,sndCode,
    address2Premise,postOfficePremise,thanaPremise,districtPremise,divisionPremise,postCodePremise,tarrifTypeCode,Load,
    meterTypeCode,address1Mailing,address2Mailing,postOfficeMailing,thanaMailing,districtMailing,districtMailing,divisionMailing,postCodeMailing,premiseTypeCode,premiseCategoryCode]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const handleClickAlert = () => {
    setOpenSnackbar(false);
  };
  const [loading, setLoading] = useState(false);
  const submitHandler = () => {
    setLoading(true);
    ticketService
      .newConnectionRequestData(JSON.stringify(newConnectionData))
      .then((response) => {
        if (
          response?.data?.createNewConnectionReqTicket?.caseId
        ) {
          let trackingNumber=Array.isArray(response?.data?.createNewConnectionReqTicket?.caseId)?response?.data?.createNewConnectionReqTicket?.caseId.map(trackingNo=>{return trackingNo.processStoreId}).join(','):response?.data?.createNewConnectionReqTicket?.caseId['processStoreId']
          setOpenSnackbar(true);
          setLoading(false);
          setError(false);
          setApplicationDate(moment());
          setTicketNumber(trackingNumber);
          setActiveStep(4);
        } else {
          setLoading(false);
          setError(true);
          setOpenSnackbar(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setError(true);
        setOpenSnackbar(true);
      });
  };
  return (
    <>
      <Grid className={summaryClass.contentBg}>
        <Card
          className={summaryClass.cardStyle}
          style={{ overflowY: browserName === "firefox" ? "auto" : "overlay" }}
        >
          <CardContent className={summaryClass.cardContentPadding}>
            <Grid container className={summaryClass.marg}>
              <Grid item>
                <Button
                  className={summaryClass.back}
                  size="small"
                  startIcon={<ArrowBackIosIcon fontSize="small" />}
                  onClick={backCall}
                  align="left"
                >
                  <Typography variant="button" className={summaryClass.back}>
                    {summaryReviewLabel?.E_BACK_LABEL}
                  </Typography>
                </Button>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h5" className={summaryClass.header}>
                  {summaryReviewLabel?.E_MAIN_TITLE}
                </Typography>
              </Grid>
            </Grid>
            <Divider className={summaryClass.divider} />
            <Grid className={summaryClass.details}>
              <ESummaryDetails
                setActiveStep={setActiveStep}
                name={name}
                fatherName={fatherName}
                husbandWifeRadio={husbandWifeRadio}
                husbandName={husbandName}
                motherName={motherName}
                email={email}
                mobile={mobile}
                idType={idType}
                idValue={idValue}
                tinValue={tinValue}
                noOfConnections={noofconnections}
                dropDownData={dropDownData}
                individualVerifiedMobile={individualVerifiedMobile}
                tarrifType={tarrifType}
                Load={Load}
                meterType={meterType}
                idTypeOthers={idTypeOthers}
                isIndividualMobileVerified={isIndividualMobileVerified}
                existingCustomer={existingCustomer}
                existingCustomerID={existingCustomerID}
                connectionType={connectionType}
                sameAsPremiseCheck={sameAsPremiseCheck}
                handleClickOpen={handleClickOpen}
                districtPremise={districtPremise}
                address1Premise={address1Premise}
                address2Premise={address2Premise}
                postOfficePremise={postOfficePremise}
                divisionPremise={divisionPremise}
                postCodePremise={postCodePremise}
                thanaPremise={thanaPremise}
                sndValue={sndValue}
                districtMailing={districtMailing}
                address1Mailing={address1Mailing}
                address2Mailing={address2Mailing}
                postOfficeMailing={postOfficeMailing}
                divisionMailing={divisionMailing}
                postCodeMailing={postCodeMailing}
                thanaMailing={thanaMailing}
                checkBoxEnable={checkBoxEnable}
                connectionOnExistingPremise={connectionOnExistingPremise}
                premiseType={premiseType}
                premiseCategory={premiseCategory}
                termsAgreedTime={termsAgreedTime}
                connectionTypeCode={connectionTypeCode}
                documentList={documentList}
                allAttachedFiles={allAttachedFiles}
                masterDataName={masterDataName}
                masterDataFatherName={masterDataFatherName}
                masterDataMotherName={masterDataMotherName}
                masterDataHusbandName={masterDataHusbandName}
                userEnteredMobileNumber={userEnteredMobileNumber}
                masterDataEmail={masterDataEmail}
                masterDataIdValue={masterDataIdValue}
                masterDataTinValue={masterDataTinValue}
                masterDataAddress1Mailing={masterDataAddress1Mailing}
                masterDataAddress2Mailing={masterDataAddress2Mailing}
                masterDataPostOfficeMailing={masterDataPostOfficeMailing}
                masterDataThanaMailing={masterDataThanaMailing}
                masterDataDistrictMailing={masterDataDistrictMailing}
                masterDataDivisionMailing={masterDataDivisionMailing}
                masterDataPostCodeMailing={masterDataPostCodeMailing}
                masterDatahusbandWifeRadio={masterDatahusbandWifeRadio}
              />
            </Grid>
            {openSnackbar === true ? (
              <Grid className={summaryClass?.alert}>
                <Alert severity="error" onClose={handleClickAlert}>
                  {summaryReviewLabel?.E_ALERT_LABEL}
                </Alert>
              </Grid>
            ) : null}
            <Grid>
              <EConfirmation submitHandler={submitHandler} loading={loading} />
            </Grid>
          </CardContent>
        </Card>
        <Grid justify="center" className={summaryClass.padding}>
          <EFooter />
        </Grid>
      </Grid>
    </>
  );
}